import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { ContractsPayload } from 'Interfaces/Contract';
import { $actions } from 'Store';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: ContractsPayload) =>
    $actions.contracts.getFormRequestContracts(dispatch, payload),
  );
};
